import type { SxProps } from "@mui/material";
import { Box, Paper, Tooltip } from "@mui/material";
import type { FC } from "react";
import type { ChannelName } from "../types";
import { prettyChannelName } from "../utils";
import { ChannelIcon } from "./channel-icon";

interface ChannelProps {
  name: ChannelName;
  buttonText: string;
  onClick: () => void;
  disabled: boolean;
  selected: boolean;
  sx?: SxProps;
}

const SIZE = 130;
const ICON_SIZE = 0.8 * 130;

export const ChannelCard: FC<ChannelProps> = ({ onClick, disabled, selected, name, sx }) => {
  return (
    <Tooltip title={prettyChannelName(name)}>
      <Paper
        variant="outlined"
        sx={{
          borderColor: selected ? "primary.main" : null,
          borderWidth: selected ? 3 : null,
          height: SIZE,
          width: SIZE,
          opacity: disabled ? 0.5 : null,
          "&:hover": {
            cursor: disabled ? null : "pointer",
            opacity: disabled ? null : 0.75,
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...sx,
        }}
        data-testid={name && "channel-card-" + name}
        data-selected={selected}
        onClick={() => !disabled && onClick && onClick()}
      >
        <Box>
          <ChannelIcon channel={name} sx={{ width: ICON_SIZE, height: ICON_SIZE }} />
        </Box>
      </Paper>
    </Tooltip>
  );
};
